import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtProjectUserGroup, MtProjectGroup } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    ProjectUserGroupProps,
    ProjectGroupFilters,

    SortProjectGroups,
    AddProjectUserGroup,

    closeModal,
    setNotAssignedProjectUserGroupIds,
    setNotAssignedProjectUserGroupSort,
    setNotAssignedProjectUserGroupFilters,
    setNotAssignedProjectUserGroupSelected,
    setProjectUserGroupReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import ProjectGroupSearch from "client/pages/search/projectGroupSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedGroups = ({
    user,
}: ProjectUserGroupProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const groupList = useSelector((state: StoreType) => state.projectGroup.groupList)
    const userGroupList = useSelector((state: StoreType) => state.projectUserGroup.userGroupList)

    const groupIds = useSelector((state: StoreType) => state.projectUserGroup.notAssignedGroups.groupIds)
    const sortColumn = useSelector((state: StoreType) => state.projectUserGroup.notAssignedGroups.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.projectUserGroup.notAssignedGroups.sortOrder)
    const filters = useSelector((state: StoreType) => state.projectUserGroup.notAssignedGroups.filters)
    const selected = useSelector((state: StoreType) => state.projectUserGroup.notAssignedGroups.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedGroupIds = SortProjectGroups(Object.values(groupList), sortColumn, sortOrder, filters)
        const userGroupIds = (userGroupList && userGroupList[user.id]) || []

        const sortedNotAssigned = sortedGroupIds.filter((groupId) => !userGroupIds.includes(groupId))
        dispatch(setNotAssignedProjectUserGroupIds(sortedNotAssigned))
    }, [userGroupList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtProjectGroup, order) => {
        dispatch(setNotAssignedProjectUserGroupSort(column, order))
    }

    const onFilter = (newFilters: ProjectGroupFilters) => {
        dispatch(setNotAssignedProjectUserGroupFilters(newFilters))
        dispatch(setNotAssignedProjectUserGroupSelected(null))
    }

    const addUserGroups = () => {
        setSaveState(PENDING)
        const data: MtProjectUserGroup[] = []
        selected.forEach((groupId) => {
            data.push({
                userId: user.id,
                userProjectId: project.id,
                groupId,
                groupAccountId: project.accountId,
                groupProjectId: project.id,
            })
        })

        AddProjectUserGroup(data).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }
            dispatch(setNotAssignedProjectUserGroupSelected(null))

            dispatch(setProjectUserGroupReloadList(false))
            setTimeout(() => {
                dispatch(setProjectUserGroupReloadList(true))
            }, 0)
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectGroup_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <ProjectGroupSearch
                        id="notAssignedProjectUserGroups"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={groupList}
                    dataIds={groupIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button variant="success" onClick={addUserGroups}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedGroups
